<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="listQuery.user_id" placeholder="请输入用户ID" style="width: 200px;" class="filter-item" clearable/>
      <el-input v-model="listQuery.nickname" placeholder="请输入用户昵称" style="width: 200px;" class="filter-item" clearable/>
      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>
    <div>用户数量：{{total}}</div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row>
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{scope.row.id}}
        </template>
      </el-table-column>
      <el-table-column label="头像" min-width="110" align="center">
        <template slot-scope="scope">
          <el-image
            style="height: 60px"
            :preview-src-list="[scope.row.avatar]"
            :src="scope.row.avatar"
            class="banner-image"
            lazy
          />
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="110" align="center">
        <template slot-scope="scope"> {{scope.row.nickname}}
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="110" align="center">
        <template slot-scope="scope"> {{scope.row.phone}}
        </template>
      </el-table-column>
      <el-table-column label="性别" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.gender==0">女</el-tag>
          <el-tag type="primary" v-else-if="scope.row.gender==1">男</el-tag>
          <el-tag type="danger"  v-else>未设置</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="粉丝数" min-width="110" align="center">
        <template slot-scope="scope"> {{scope.row.be_follow_count}}
        </template>
      </el-table-column>
      <el-table-column label="关注数" min-width="110" align="center">
        <template slot-scope="scope"> {{scope.row.follow_count}}
        </template>
      </el-table-column>
      <el-table-column label="发帖数" min-width="110" align="center">
        <template slot-scope="scope"> {{scope.row.post_num}}
        </template>
      </el-table-column>
      <el-table-column label="浏览数" min-width="110" align="center">
        <template slot-scope="scope"> {{scope.row.browse_num}}
        </template>
      </el-table-column>
      <el-table-column label="评论数" min-width="110" align="center">
        <template slot-scope="scope"> {{scope.row.post_message_num}}
        </template>
      </el-table-column>
      <el-table-column label="是否官方用户" min-width="110" align="center">
        <template slot-scope="scope"> {{scope.row.is_official_user}}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal == 1" type="success">正常</el-tag>
          <el-tag v-else type="danger">已冻结</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="scope.row.is_official_user == 1" size="mini" type="danger" @click="handleOfficialUser(scope.row.id, '取消官方用户')">取消官方用户</el-button>
          <el-button v-else size="mini" type="success" @click="handleOfficialUser(scope.row.id, '设为官方用户')">设为官方用户</el-button>
          <el-button v-if="scope.row.is_normal == 1" size="mini" type="danger" @click="handleStatus(scope.row.id, '冻结')">冻结</el-button>
          <el-button v-else size="mini" type="success" @click="handleStatus(scope.row.id, '解冻')">解冻</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>

  </div>
</template>

<script>

  import request from '@/utils/request'

  export default {
    data() {
      return {
        list: [],
        total: null,
        listLoading: false,
        listQuery: {
          page: 1,
          limit: 10,
          user_id: '',
          nickname: '',
          is_normal: '',
        },
        dialogFormVisible: false,
        form: {
          id: '',
          name: '',
        },
        rules: {
          name: [{ required: true, message: '院系不能为空', trigger: 'change' }],
        },
        btnLoading: false,
      }
    },
    created() {
      this.getList()
    },
    methods: {
      getList() {
        this.listLoading = true
        request({
          url: '/api/backend/post/userList',
          method: 'get',
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data
          this.total = response.data.total
          this.listLoading = false
        })
      },
      handleFilter() {
        this.listQuery.page = 1
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.limit = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.listQuery.page = val
        this.getList()
      },
      resetForm() {
        this.form = {
          id: '',
          name: '',
        }
      },
      //上下架
      handleStatus(val,text) {
        this.$confirm('此操作将'+text+'该院系, 是否继续?', '提示', {
          type: 'warning'
        }).then(() => {
          request({
            url: '/api/backend/users/changeNormal',
            method: 'post',
            data: {id: val}
          }).then(()=>{
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功'
            });
          })
        }).catch(() => {});
      },

       //上下架
      handleOfficialUser(val,text) {
        this.$confirm('此操作将'+text+', 是否继续?', '提示', {
          type: 'warning'
        }).then(() => {
          request({
            url: '/api/backend/post/changeOfficialUser',
            method: 'post',
            data: {id: val}
          }).then(()=>{
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功'
            });
          })
        }).catch(() => {});
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>